import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { APPLICATION_TYPE, CURRENT_CLIENT_ID_KEY } from '@core';

import { MainLogoComponent } from '../main-logo/main-logo.component';

@Component({
  imports: [MainLogoComponent, RouterLink],
  selector: 'avs-error-404',
  templateUrl: './error-404.component.html',
})
export class Error404Component {
  protected isMobile = inject(APPLICATION_TYPE) === 'mobile';
  protected authenticatedContext = !!inject(ActivatedRoute).snapshot.queryParams[CURRENT_CLIENT_ID_KEY];
}
